import React from 'react'
import { useTranslation } from 'react-i18next';

function Termcond() {
  const { t } = useTranslation();

  return (
  <main className="page-content">
  <div className="tm-about-area tm-padding-section bg-white">
    <div className="container">
      <div className="row align-items-center">
        <div className="col-lg-12">
          <div className="tm-about-content">
            <h4>{t("TC1")}</h4>
            <h6>{t("TC2")}</h6>
            <p>{t("TC3")}</p>
            <h6>{t("TC4")}</h6>
            <p>{t("TC5")}</p>
            <h6>{t("TC6")}</h6>
            <p>{t("TC7")}</p>
            <h6>{t("TC8")}</h6>
            <p>{t("TC9")}</p>
            <h6>{t("TC10")}</h6>
            <p>{t("TC11")}</p>
            <h6>{t("TC12")}</h6>
            <p>{t("TC13")}</p>
            <h6>{t("TC14")}</h6>
            <p>{t("TC15")}</p>
            <h6>{t("TC16")}</h6>
            <p>{t("TC17")}</p>
            <h6>{t("TC18")}</h6>
            <p>{t("TC19")}</p>
            <h6>{t("TC20")}</h6>
            <p>{t("TC21")}</p>
            <h6>{t("TC22")}</h6>
            <p>{t("TC23")}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>

  )
}

export default Termcond